import Modal from '../../components/ui/Modal';
import FileChatPanel from './FileChatPanel';

/**
 * Live chat in a dialog (opened from file/folder rows), the sibling of
 * CommentsModal. Modal returns null when closed, so the panel — and with it the
 * socket subscription and polling — only exists while the dialog is open.
 */
export default function ChatModal({ open, onClose, target }) {
  return (
    <Modal open={open} onClose={onClose} title={target ? `Chat — ${target.item.name}` : 'Chat'}>
      <div className="h-[60vh] min-h-0">
        <FileChatPanel targetType={target?.type} targetId={target?.item?.id} />
      </div>
    </Modal>
  );
}
